import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";

export default function Signup() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await register(form.name, form.email, form.password); toast.success("Account created!"); nav("/"); }
    catch (err) { const d = err.response?.data?.detail; toast.error(typeof d === "string" ? d : "Signup failed"); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center mb-8">
          <img src="/logo.png" alt="Faridabad Properties" className="h-12 w-auto" />
        </Link>
        <div className="bg-white rounded-2xl border border-slate-200 p-8 shadow-sm">
          <h1 className="font-heading text-2xl font-bold text-slate-900">Create your account</h1>
          <p className="text-slate-500 text-sm mt-1">Save properties and get assistance faster.</p>
          <form onSubmit={submit} className="space-y-4 mt-6" data-testid="signup-form">
            <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Full Name" data-testid="signup-name" className="w-full px-4 py-3 rounded-xl border border-slate-200 text-sm" />
            <input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="Email" data-testid="signup-email" className="w-full px-4 py-3 rounded-xl border border-slate-200 text-sm" />
            <input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="Password" data-testid="signup-password" className="w-full px-4 py-3 rounded-xl border border-slate-200 text-sm" />
            <Button type="submit" disabled={loading} data-testid="signup-submit" className="w-full bg-indigo-900 hover:bg-indigo-800">{loading ? "Creating…" : "Sign Up"}</Button>
          </form>
          <p className="text-sm text-slate-500 mt-4 text-center">Have an account? <Link to="/login" className="text-indigo-800 font-semibold">Login</Link></p>
        </div>
      </div>
    </div>
  );
}
